import { Injectable } from '@angular/core';
import { CanActivate, Router, NavigationStart, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  navStart: Observable<NavigationStart>;
  requestedUrl: any = '';


  constructor(private router: Router) {
    this.navStart = router.events.pipe(
      filter(evt => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;
  }
  isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    }
    else {
      return false;
    }
  }

  checkSettings() {
    // if (!this.isMobile()) {
    //   var exsistSettings = localStorage.getItem("printingSettings");
    //   if (this.router.url != '/dashboard/settings') {
    //     if (exsistSettings == null || exsistSettings == undefined) {
    //       this.router.navigate(['/dashboard/settings']);
    //       return true;
    //     }
    //     else {
    //       return true;
    //     }
    //   }
    //   else {
    //     if (exsistSettings)
    //       return true;
    //     else
    //       return false;
    //   }
    // }
    // else {
    //   return true;
    // }

    return true;
  }

  checkRoles(state: RouterStateSnapshot) {
    var userRoles = JSON.parse(sessionStorage.getItem("user")).Roles;
    var hasCashierRole = userRoles.filter(x => x.Type == 1).length > 0;
    var hasOutletManagerRole = userRoles.filter(x => x.Type == 2).length > 0;
    var hasOperationsRole = userRoles.filter(x => x.Type == 3).length > 0;

    //this.navStart.subscribe(evt => {
    //  this.requestedUrl = evt.url;
    //})

    this.requestedUrl = state.url;
    
    if (this.requestedUrl.includes('operations'))
      return hasOperationsRole;
    else if (this.requestedUrl.includes('cashier'))
      return hasCashierRole;
    else if (this.requestedUrl.includes('outlet-manager'))
      return hasOutletManagerRole;
    else if (this.requestedUrl.includes('settings'))
      return hasCashierRole;
    else
      return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    return (this.checkSettings() && this.checkRoles(state));
  }


}
